import { createAction, createSlice } from '@reduxjs/toolkit';

export const fetchSurveyOutcomes = createAction(
  'patientOutcomes/fetchSurveyOutcomes'
);

const patientOutcomes = createSlice({
  name: 'patientOutcomes',
  initialState: {
    surveyAnalyticsData: []
  },
  reducers: {
    fetchSurveyOutcomesSuccess(state, action) {
      const { data } = action.payload;
      state.surveyAnalyticsData = data;
    }
  }
});

export const { fetchSurveyOutcomesSuccess } = patientOutcomes.actions;

export default patientOutcomes.reducer;
